import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const links = ['Inicio', 'Proyectos', 'Construcción', 'Servicios', 'Nuestro equipo', 'Proceso', 'Sobre nosotros', 'Contacto'];
const anchors = ['inicio', 'proyectos', 'construccion', 'servicios', 'equipo', 'proceso', 'sobre-mi', 'contacto'];
export function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled || open ? 'bg-[#f7f4ef]/95 shadow-sm backdrop-blur-md' : 'bg-transparent'}`} data-id="element-133" data-mp="f0bz1363w5zd">
      <nav className="mx-auto flex h-20 max-w-[1440px] items-center justify-between px-5 md:px-10" data-id="element-134" data-mp="oz1ih0dnhyhq">
        <a href="#inicio" className={`font-editorial text-xl tracking-tight ${scrolled || open ? 'text-[#1A1A1A]' : 'text-white'}`} data-id="element-135" data-mp="dfz3ddx2exg0">
          VC <span className="italic" data-id="element-136" data-mp="hjdlca4kdnw3">Estudio</span>
        </a>
        <div className={`hidden items-center gap-6 text-[11px] font-semibold uppercase tracking-[.13em] lg:flex ${scrolled ? 'text-[#1A1A1A]' : 'text-white'}`} data-id="element-137" data-mp="mfcgcgkee45h">
          {links.map((link, i) => <a className="transition-colors hover:text-[#C4724A]" key={link} href={`#${anchors[i]}`} data-id="element-138" data-mp="we206evutyod" data-mpi={i}>
              {link}
            </a>)}
        </div>
        <button aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className={`p-2 lg:hidden ${scrolled || open ? 'text-[#1A1A1A]' : 'text-white'}`} onClick={() => setOpen(!open)} data-id="element-139" data-mp="158yibwxjylod">
          {open ? <XIcon size={24} data-id="element-140" data-mp="1k45t9sbf2g14" /> : <MenuIcon size={24} data-id="element-141" data-mp="1k3csr931wmrf" />}
        </button>
      </nav>
      {open && <div className="border-t border-[#ded7ce] bg-[#F7F4EF] px-5 py-6 lg:hidden" data-id="element-142" data-mp="ufqwbvmau0t9">
          <div className="flex flex-col gap-5 text-sm font-semibold" data-id="element-143" data-mp="udnywqith5ei">
            {links.map((link, i) => <a onClick={() => setOpen(false)} key={link} href={`#${anchors[i]}`} data-id="element-144" data-mp="145junuxfkjfk" data-mpi={i}>
                {link}
              </a>)}
            <a onClick={() => setOpen(false)} href="#contacto" className="mt-1 w-fit bg-[#C4724A] px-5 py-3 text-xs font-bold uppercase tracking-wider text-white" data-id="element-145" data-mp="1d6892qqqklsz">
              Hablemos
            </a>
          </div>
        </div>}
    </header>;
}